// extracted by mini-css-extract-plugin
export default {"tree":"MultiDepartEditModal_tree__T61oJ","setPrimary":"MultiDepartEditModal_setPrimary__w6Cc9","item":"MultiDepartEditModal_item__y2Ejl"};